<template>
  <div class="on-print">
    <v-dialog v-model="loginDialog" width="400">
      <LoginDialog />
    </v-dialog>

    <div v-if="!globalStatus" class="on-print">
      <toolbar />
      <navbar />
      <v-main>
        <CancelDialog
          :show="showCancel"
          :forced="forceSubscriptionAction"
          :dismissalCount="subscriptionDismissalCount"
          :subscriptionStatus="subscriptionStatus"
          @dismissed="dismissCanceledNotice"
          @gotoAccount="gotoAccount"
        />
        <router-view></router-view>
      </v-main>
      <v-footer app v-if="!$vuetify.breakpoint.xsOnly">
        <span>Need Help Call: (917) 529-7186</span>
        <v-spacer></v-spacer>
        <div>
          smplsale.com &copy; {{ new Date().getFullYear() }} | V-{{ version }}
        </div>
      </v-footer>
    </div>
    <div v-else>
      <v-dialog v-model="globalStatus" hide-overlay persistent width="300">
        <v-card color="yellow lighten-1" class="pa-3" >
          <v-card-text color="text--black">
            {{ $t("labels.pleaseStandBy") }}
            <v-progress-linear
              indeterminate
              color="black"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog v-model="loadingStatus.status" persistent width="300">
      <v-card color="yellow lighten-1" dark>
        <v-card-text>
          {{ loadingStatus.title }}
          <v-progress-linear
            indeterminate
            color="black"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import layoutStore from "./store";
import Navbar from "@/modules/Layout/components/NavigationPanel.vue";
import LoginDialog from "../Authentication/components/LoginDialog";
import Toolbar from "@/modules/Layout/components/Toolbar.vue";
import accountService from "@/modules/Account/service.js";
import backofficeService from "../../api/backoffice.js";
import CancelDialog from "@/modules/Layout/components/cancelDialog.vue";
import { mapGetters, mapActions } from "vuex";
const pjson = require("../../../package.json");

export default {
  name: "layout",
  mixins: [RegisterStoreModule],
  async created() {
    try {
      this.registerStoreModule("layout", layoutStore);
      await this.initUser();
      await this.initType();
      this.setGlobalStatus(false);
      this.pollData();
      await this.checkSubcription();
      this.startSubscriptionPolling();
      // // console.log('currentBusiness', this.currentBusiness)
      this.$store.dispatch('layout/initDrawer', this.$vuetify.breakpoint.xsOnly)
    } catch (error) {
      this.$router.push("/logout");
    }
  },
  components: {
    Navbar,
    CancelDialog,
    Toolbar,
    LoginDialog,
  },
  // sockets: {
  //   connect: function() {
  //     // // console.log('socket connected')
  //     this.joinSocket();
  //   },
  //   message: function(data) {
  //     // // console.log('message', data)
  //   }
  // },
  computed: {
    ...mapGetters("global", [
      "currentUser",
      "currentBusiness",
      "globalStatus",
      "loadingStatus",
      "loginDialog",
    ]),
    version() {
      return pjson.version;
    },
  },
  props: {
    source: String,
  },
  data() {
    return {
      subscriptionStatus: "active",
      showCancel: false,
      include: ["home", "customer-home"],
      authenticated: true,
      polling: null,
      Subscription: null,
      forceSubscriptionAction: false,
      subscriptionDismissalCount: 0,
      subscriptionPolling: null,
      subscriptionCheckInProgress: false,
      lastSubscriptionCheckAt: 0,
    };
  },
  watch: {
    authenticated(val) {
      if (!val) {
        this.$swal(
          "Session Expired",
          "Your token was expaired please login again.",
          "warning"
        ).then(() => {
          // this.$router.push("/login");
          this.setLoginDialog(true);
        });
      }
    },
  },
  methods: {
    ...mapActions("layout", ["setSubscriptionState"]),
    ...mapActions("global", [
      "setGlobalStatus",
      "setLoginDialog",
      "initUser",
      "initType",
    ]),
    async checkSubcription() {
      if (this.subscriptionCheckInProgress) return;

      if (!this.currentBusiness || !this.currentBusiness.subscribable) {
        this.setSubscriptionState({
          checked: true,
          loading: false,
          status: "not_required",
          data: null,
          error: null,
        });
        this.lastSubscriptionCheckAt = Date.now();
        return;
      }

      if (!this.currentBusiness.subscription_id) {
        this.subscriptionStatus = "missing";
        this.setSubscriptionState({
          checked: true,
          loading: false,
          status: "missing",
          data: null,
          error: null,
        });
        this.lastSubscriptionCheckAt = Date.now();
        return;
      }

      this.subscriptionCheckInProgress = true;
      try {
        await this.getSubscription();
      } finally {
        this.subscriptionCheckInProgress = false;
        this.lastSubscriptionCheckAt = Date.now();
      }
    },
    startSubscriptionPolling() {
      if (!this.currentBusiness || !this.currentBusiness.subscribable) return;
      this.stopSubscriptionPolling();
      this.subscriptionPolling = setInterval(() => {
        this.checkSubcription();
      }, 60 * 60 * 1000);
      document.addEventListener("visibilitychange", this.handleSubscriptionVisibility);
    },
    stopSubscriptionPolling() {
      if (this.subscriptionPolling) {
        clearInterval(this.subscriptionPolling);
        this.subscriptionPolling = null;
      }
      document.removeEventListener("visibilitychange", this.handleSubscriptionVisibility);
    },
    handleSubscriptionVisibility() {
      const oneHour = 60 * 60 * 1000;
      if (
        document.visibilityState === "visible" &&
        Date.now() - this.lastSubscriptionCheckAt >= oneHour
      ) {
        this.checkSubcription();
      }
    },
    canceledNoticeKey() {
      const businessId = this.currentBusiness && (this.currentBusiness.id || this.currentBusiness.code);
      return `${process.env.VUE_APP_STORAGE_PREFIX || "smplsale-"}canceled-subscription-dismissals-${businessId}`;
    },
    prepareCanceledNotice() {
      const count = Number(localStorage.getItem(this.canceledNoticeKey()) || 0);
      this.subscriptionDismissalCount = Math.min(count, 5);
      this.forceSubscriptionAction = count >= 5;
      this.showCancel = true;
    },
    dismissCanceledNotice() {
      const key = this.canceledNoticeKey();
      const count = Number(localStorage.getItem(key) || 0);
      const nextCount = Math.min(count + 1, 5);
      localStorage.setItem(key, String(nextCount));
      this.subscriptionDismissalCount = nextCount;
      this.showCancel = false;
    },
    resetCanceledNoticeCount() {
      if (this.currentBusiness) localStorage.removeItem(this.canceledNoticeKey());
      this.forceSubscriptionAction = false;
      this.subscriptionDismissalCount = 0;
      this.showCancel = false;
    },
    gotoAccount() {
      this.showCancel = false;
      this.$router.push("/account");
    },
    getSubscription() {
      this.setSubscriptionState({ loading: true, error: null });
      return accountService
        .getSubscription({
          subscription_id: this.currentBusiness.subscription_id,
        })
        .then((result) => {
          // console.log("asdfksdfsdf", result);
          this.Subscription = result.data;
          this.subscriptionStatus = this.Subscription.status || "unknown";
          this.setSubscriptionState({
            checked: true,
            loading: false,
            status: this.subscriptionStatus,
            data: this.Subscription,
            error: null,
          });
          if (["canceled", "incomplete_expired"].includes(this.subscriptionStatus)) {
            this.prepareCanceledNotice();
          } else if (["active", "trialing"].includes(this.subscriptionStatus)) {
            this.resetCanceledNoticeCount();
          }
        })
        .catch((error) => {
          console.error("subscription check failed", error);
          this.subscriptionStatus = "unavailable";
          this.setSubscriptionState({
            checked: true,
            loading: false,
            status: "unavailable",
            data: null,
            error: error && error.message ? error.message : "Unable to verify subscription",
          });
        });
    },
    // sendSocket(data) {
    //   // // console.log('sendSocket', data)
    //   this.$socket.emit("userStatus", data);
    // },
    // joinSocket() {
    //   if (this.currentUser) {
    //     this.$socket.emit("join", this.currentUser);
    //   }
    // },
    async checkToken() {
      this.authenticated = await backofficeService.valid();
    },
    pollData() {
      this.polling = setInterval(() => {
        if (
          !localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`)
        ) {
          this.authenticated = false;
        }
      }, 1000);
    },
  },
  beforeDestroy() {
    this.stopSubscriptionPolling();
    if (this.polling) clearInterval(this.polling);
  },
};
</script>
